export enum InterviewStatus {
  SCHEDULED = "scheduled",
  IN_PROGRESS = "in_progress",
  COMPLETED = "completed",
  CANCELLED = "cancelled"
}

export interface InterviewData {
  id: string;
  status: InterviewStatus;
  expires_at: string;
}

export interface TalentData {
  id: string;
  name: string;
  email: string;
}

export interface JobOfferData {
  id: string;
  title: string;
  description: string;
  education_requirements?: string;
  skills?: Array<string | { name: string; importance: string }>;
  coding_languages?: string[];
  frameworks_libraries?: string[];
  business_knowledge?: string[];
  soft_skills?: string[];
  years_of_experience?: number;
  custom_instructions?: string;
  remote_policy?: string;
  contract_type?: string;
  location?: string;
  required_degree?: string;
  company_name?: string;
  company_sector?: string;
  company_size?: number;
  company_description?: string;
  mission_role_in_job?: string;
}

export interface InterviewOverview {
  duration_minutes: number | null;
  spoken_question_count: number;
  coding_question_count: number;
  coding_languages: string[];
  questionnaire_count: number;
  questionnaire_minutes: number | null;
  introduction_question_count: number;
  technical_spoken_count: number;
  technical_coding_count: number;
  technical_minutes: number | null;
  soft_skills_question_count: number;
  soft_skills_minutes: number | null;
}

export interface InterviewResponse {
  interview: InterviewData;
  talent: TalentData;
  job_offer: JobOfferData;
  overview?: InterviewOverview | null;
  locale?: string;
  workspace_logo_url?: string;
  workspace_primary_color?: string | null;
  workspace_secondary_color?: string | null;
} 
